// src/data/projects/entries/jungle.js
const project = {
  slug: "jungle",
  title: "Raising the Alley: A Vertical Public Realm over Donui-dong",
  category: "Student Project",
  date: "2021/06",
  excerpt: "Urban-regeneration proposal for Donui-dong’s jjokbangchon that preserves the ground-level alley texture as exhibition/retail, caps it with a structural pedestrian deck as shared open space, and adds compliant one-person housing above—supplemented by lifestyle lodging to make participation economically viable.",
  hero: "/images/projects/jungle/hero.png",
  heroSmall: "/images/projects/jungle/hero.png",
  heroThumb: "/images/projects/jungle/hero.thumb.png",
  thumb: "/images/projects/jungle/thumbnail.png",
  thumbPlaceholder: "/images/projects/jungle/thumbnail.thumb.png",
  content: [
    {
      type: "paragraph",
      text: `Donui-dong in central Seoul is home to one of the city's last remaining jjokbangchon—an informal settlement of tiny one-room dwellings. Here, about 576 residents live in cramped units as small as 1.25 pyeong (4 square meters) across a maze of 88 aging buildings. These alleys are a world of their own: narrow, densely packed, and largely hidden amidst the surrounding city. The living conditions are severe, with many inhabitants being elderly or formerly homeless individuals barely scraping by. Yet the neighborhood's labyrinthine character and tightly-knit social fabric carry a certain intrigue and sense of community.`,
    },
    {
      type: "image",
      src: "/images/projects/jungle/jungle_1.png",
      alt: "Raising the Alley project image 1",
      placeholder: "/images/projects/jungle/jungle_1.thumb.png",
    },
    {
      type: "paragraph",
      text: `This studio project confronts the social challenges of Donui-dong's jjokbangchon with a bold, layered design approach. Visiting the site, the designers observed that from within the alleys, the sky was barely visible above the tightly-packed shacks. This observation inspired the concept of raising the alley—literally elevating the communal ground to give residents space, light, and a new vantage point. The design seeks to create an opportunity for upward movement (both physical and social) for the jjokbangchon's residents, without erasing the area's identity.`,
    },
    {
      type: "image",
      src: "/images/projects/jungle/jungle_2.png",
      alt: "Raising the Alley project image 2",
      placeholder: "/images/projects/jungle/jungle_2.thumb.png",
    },
    {
      type: "paragraph",
      text: `Instead of wholesale demolition, the proposal preserves portions of the existing alley fabric at ground level, maintaining the authentic maze-like atmosphere. These retained structures and narrow passages are repurposed into a sort of living museum—housing small exhibits, workshops, and retail that showcase the history and stories of the jjokbangchon. The familiar gritty alleyway environment thus remains accessible, now inviting visitors to explore and learn, while providing former residents an anchor to their past. By keeping the ground plane alive and recognizable, the design ensures the spirit of Donui-dong is not lost in redevelopment.`,
    },
    {
      type: "image",
      src: "/images/projects/jungle/jungle_3.png",
      alt: "Raising the Alley project image 3",
      placeholder: "/images/projects/jungle/jungle_3.thumb.png",
    },
    {
      type: "paragraph",
      text: `Above this preserved ground, a new elevated pedestrian network is introduced—essentially raising the alley into the air. A bold structural platform weaves over the site, creating an open public realm one level up. This elevated promenade becomes the new heart of the community: an outdoor hallway and terrace where residents can stroll, gather, and enjoy sunlight and fresh air, all within their own neighborhood. By covering the old alleys with this structural walk, the design also adds a dramatic spatial layer that sparks curiosity and draws outsiders to venture in.`,
    },
    {
      type: "image",
      src: "/images/projects/jungle/jungle_4.png",
      alt: "Raising the Alley project image 4",
      placeholder: "/images/projects/jungle/jungle_4.thumb.png",
    },
    {
      type: "paragraph",
      text: `On top of the pedestrian deck, the project then introduces new housing and other programs. Clusters of code-compliant micro-unit apartments are built above, providing safe and decent homes for the jjokbangchon's residents. These units are compact but thoughtfully designed to meet modern standards, offering dignity and stability in place of the former 1.25-pyeong rooms. In addition, one portion of the site is dedicated to a lifestyle lodging tower—essentially a small hotel or serviced residence—that generates revenue. This mix of programs establishes a sustainable financial model: the lodging draws visitors and income that help support the subsidized housing and persuade landowners to invest in the renewal.`,
    },
    {
      type: "image",
      src: "/images/projects/jungle/jungle_5.png",
      alt: "Raising the Alley project image 5",
      placeholder: "/images/projects/jungle/jungle_5.thumb.png",
    },
    {
      type: "paragraph",
      text: `The result is a layered village that uplifts its residents while inviting the city in. By strategically combining social housing with commercial uses, the scheme achieves both community benefit and economic viability. Most importantly, it retains the soul of Donui-dong—the intimate alleyways and their stories—rather than replacing them with anonymous towers. Raising the Alley demonstrates a compassionate approach to urban regeneration: one that builds upward toward hope while keeping the roots of the place firmly intact.`,
    },
    {
      type: "image",
      src: "/images/projects/jungle/jungle_6.png",
      alt: "Raising the Alley project image 6",
      placeholder: "/images/projects/jungle/jungle_6.thumb.png",
    },
  ],
};

export default project;
